/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import tradly from 'tradly';

export const get_orders = createAsyncThunk(
  'order/get_orders',
  async ({ authKey, bodyParam }, thunkAPI) => {
    try {
      const response = await axios.get('/api/orders', { params: bodyParam });
      const { data } = await response;
      if (!response.data.error) {
        return data;
      } else {
        const { error } = await response.data;
        return error;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const get_orders_by_calender = createAsyncThunk(
  'order/get_orders_by_calender',
  async ({ bodyParam }, thunkAPI) => {
    try {
      const response = await axios.get('/api/a/orders', { params: bodyParam });
      const { data } = await response;
      if (!response.data.error) {
        return data;
      } else {
        const { error } = await response.data;
        return error;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const get_order_details = createAsyncThunk(
  'order/get_order_details',
  async ({ authKey, id }, thunkAPI) => {
    try {
      const response = await axios.get(`/api/orders/${id}`);
      const { data } = await response;
      if (!response.data.error) {
        return data;
      } else {
        const { error } = await response.data;
        return error;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const changeOrderStatus = createAsyncThunk(
  'order/changeOrderStatus',
  async ({ authKey, id, sendData }, thunkAPI) => {
    try {
      const response = await axios.post('/api/orders/status', { id, sendData });
      const { data } = await response;
      if (!response.data.error) {
        return data;
      } else {
        const { error } = await response.data;
        return error;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const verifyOrderDetails = createAsyncThunk(
  'order/verifyOrderDetails',
  async ({ ...sendData }, thunkAPI) => {
    try {
      const response = await axios.post('/api/orders/verify_order', {
        data: sendData,
      });
      const { data } = await response;
      if (!response.data.error) {
        return data;
      } else {
        const { error } = await response.data;
        return error;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const changeShipmentStatus = createAsyncThunk(
  'order/changeShipmentStatus',
  async ({ id, shipment_id, sendData }, thunkAPI) => {
    try {
      const response = await axios.post('/api/shipments/status', {
        id,
        shipment_id,
        sendData,
      });
      const { data } = await response;
      if (!response.data.error) {
        return data;
      } else {
        const { error } = await response.data;
        return error;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const orderSlice = createSlice({
  name: 'order',
  initialState: {
    isFetching: false,
    isOrderByCalenderFetching: false,
    isOrderVerifying: false,

    isChangeStatusFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
    isChangeStatusError: false,
    changeStatusErrorMessage: '',
    orders: null,
    orders_list_by_calender: null,
    order_details: null,
    total_records: '',
    page: '',
    verified_order: null,
  },
  reducers: {
    clearOrderState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isFetching = false;
      state.errorMessage = '';
      return state;
    },
    clearOrderDetails: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.order_details = null;
      return state;
    },
    clearVerifiedOrder: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isOrderVerifying = false;
      state.errorMessage = '';
      state.verified_order = null;
      return state;
    },
  },
  extraReducers: {
    [get_orders.fulfilled]: (state, { payload }) => {
      if (payload.code) {
        state.isFetching = false;
        state.isError = true;
        state.isSuccess = false;
        state.errorMessage = payload?.message;
      } else {
        state.isError = false;
        state.isFetching = false;
        state.isSuccess = true;
        state.orders = payload?.orders;
        state.total_records = payload?.total_records;
        state.page = payload?.page;
      }
    },
    [get_orders.pending]: (state) => {
      state.isSuccess = false;
      state.isFetching = true;
      state.isError = false;
      state.errorMessage = '';
    },
    [get_orders.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.isSuccess = false;
      state.errorMessage = payload?.message;
    },
    //
    [get_orders_by_calender.fulfilled]: (state, { payload }) => {
      if (payload.code) {
        state.isOrderByCalenderFetching = false;
        state.isError = true;
        state.isSuccess = false;
        state.errorMessage = payload?.message;
      } else {
        state.isError = false;
        state.isOrderByCalenderFetching = false;
        state.isSuccess = true;
        state.orders_list_by_calender = payload?.orders;
      }
    },
    [get_orders_by_calender.pending]: (state) => {
      state.isSuccess = false;
      state.isOrderByCalenderFetching = true;
      state.isError = false;
      state.errorMessage = '';
    },
    [get_orders_by_calender.rejected]: (state, { payload }) => {
      state.isOrderByCalenderFetching = false;
      state.isError = true;
      state.isSuccess = false;
      state.errorMessage = payload?.message;
    },
    //
    [get_order_details.fulfilled]: (state, { payload }) => {
      if (payload.code) {
        state.isFetching = false;
        state.isError = true;
        state.isSuccess = false;
        state.errorMessage = payload?.message;
      } else {
        state.isError = false;
        state.isFetching = false;
        state.isSuccess = true;
        state.order_details = payload?.order;
      }
    },
    [get_order_details.pending]: (state) => {
      state.isSuccess = false;
      state.isFetching = true;
      state.isError = false;
      state.errorMessage = '';
    },
    [get_order_details.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.isSuccess = false;
      state.errorMessage = payload?.message;
    },

    //
    [changeOrderStatus.fulfilled]: (state, { payload }) => {
      if (payload.code) {
        state.isChangeStatusFetching = false;
        state.isChangeStatusError = true;
        state.isSuccess = false;
        state.changeStatusErrorMessage = payload?.message;
      } else {
        state.isChangeStatusError = false;
        state.isChangeStatusFetching = false;
        state.isSuccess = true;
      }
    },
    [changeOrderStatus.pending]: (state) => {
      state.isSuccess = false;
      state.isChangeStatusFetching = true;
      state.isChangeStatusError = false;
      state.changeStatusErrorMessage = '';
    },
    [changeOrderStatus.rejected]: (state, { payload }) => {
      state.isChangeStatusFetching = false;
      state.isChangeStatusError = true;
      state.changeStatusErrorMessage = payload?.message;
    },

    //
    [verifyOrderDetails.fulfilled]: (state, { payload }) => {
      console.log({ payload });
      if (payload.code) {
        state.isOrderVerifying = false;
        state.isError = true;
        state.isSuccess = false;
        state.errorMessage = payload?.message;
      } else {
        state.isOrderVerifying = false;
        state.isError = false;
        state.isSuccess = true;
        state.verified_order = payload;
      }
    },
    [verifyOrderDetails.pending]: (state) => {
      state.isSuccess = false;
      state.isOrderVerifying = true;
      state.isError = false;
      state.errorMessage = '';
    },
    [verifyOrderDetails.rejected]: (state, { payload }) => {
      state.isOrderVerifying = false;
      state.isError = true;
      state.errorMessage = payload?.message;
    },

    //
    [changeShipmentStatus.fulfilled]: (state, { payload }) => {
      if (payload.code) {
        state.isChangeStatusFetching = false;
        state.isChangeStatusError = true;
        state.isSuccess = false;
        state.changeStatusErrorMessage = payload?.message;
      } else {
        state.isChangeStatusError = false;
        state.isChangeStatusFetching = false;
        state.isSuccess = true;
      }
    },
    [changeShipmentStatus.pending]: (state) => {
      state.isSuccess = false;
      state.isChangeStatusFetching = true;
      state.isChangeStatusError = false;
      state.changeStatusErrorMessage = '';
    },
    [changeShipmentStatus.rejected]: (state, { payload }) => {
      state.isChangeStatusFetching = false;
      state.isChangeStatusError = true;
      state.isSuccess = false;
      state.changeStatusErrorMessage = payload?.message;
    },
  },
});

export const { clearOrderState, clearCOrderDetails, clearVerifiedOrder } =
  orderSlice.actions;
export const orderSelector = (state) => state.order;
